import React from 'react';

const CartContext = React.createContext({
  items: [],
  totalAmount: 0,
  showFooter: true,
  addItem: (item) => {},
  removeItem: (id) => {},
  clear: () => {},
  setShowFooter: (show) => {}
});

export default CartContext;
